const risk = {
  en: {
    band: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      noData: 'No data',
    },
    trigger: {
      scheduled_weekly: 'Weekly',
      event_module_completed: 'Module completed',
      event_course_completed: 'Course completed',
      event_assignment_graded: 'Assignment graded',
      event_exam_completed: 'Exam completed',
      rule_based_detection: 'Rule-based detection',
      manual_refresh: 'Manual refresh',
      course_enrollment: 'Course enrollment',
      stale_refresh: 'Stale refresh',
      unknown: 'Unknown',
    },
    factor: {
      low_engagement: 'Low engagement',
      missed_deadlines: 'Missed deadlines',
      low_quiz_scores: 'Low quiz scores',
      inactive: 'Inactive',
      inactivity: 'Inactivity',
      declining_progress: 'Declining progress',
      slow_progress: 'Slow progress',
      repeated_failures: 'Repeated failures',
      no_recent_activity: 'No recent activity',
    },
  },
  ru: {
    band: {
      high: 'Высокий',
      medium: 'Средний',
      low: 'Низкий',
      noData: 'Нет данных',
    },
    trigger: {
      scheduled_weekly: 'Еженедельно',
      event_module_completed: 'Модуль завершён',
      event_course_completed: 'Курс завершён',
      event_assignment_graded: 'Задание оценено',
      event_exam_completed: 'Экзамен завершён',
      rule_based_detection: 'Автоматическое обнаружение',
      manual_refresh: 'Ручное обновление',
      course_enrollment: 'Запись на курс',
      stale_refresh: 'Устаревшее обновление',
      unknown: 'Неизвестно',
    },
    factor: {
      low_engagement: 'Низкая вовлечённость',
      missed_deadlines: 'Пропущенные сроки',
      low_quiz_scores: 'Низкие баллы за тесты',
      inactive: 'Неактивность',
      inactivity: 'Неактивность',
      declining_progress: 'Прогресс снижается',
      slow_progress: 'Медленный прогресс',
      repeated_failures: 'Повторные неудачи',
      no_recent_activity: 'Нет недавней активности',
    },
  },
  uz: {
    band: {
      high: 'Yuqori',
      medium: "O'rta",
      low: 'Past',
      noData: "Ma'lumot yo'q",
    },
    trigger: {
      scheduled_weekly: 'Haftalik',
      event_module_completed: 'Modul yakunlandi',
      event_course_completed: 'Kurs yakunlandi',
      event_assignment_graded: 'Topshiriq baholandi',
      event_exam_completed: 'Imtihon yakunlandi',
      rule_based_detection: "Qoidaga asoslangan aniqlash",
      manual_refresh: "Qo'lda yangilash",
      course_enrollment: 'Kursga yozilish',
      stale_refresh: 'Eskirgan yangilash',
      unknown: "Noma'lum",
    },
    factor: {
      low_engagement: 'Faollik past',
      missed_deadlines: "Muddatlar o'tkazib yuborilgan",
      low_quiz_scores: 'Test baholari past',
      inactive: 'Nofaol',
      inactivity: 'Nofaollik',
      declining_progress: 'Progress pasaymoqda',
      slow_progress: "Progress sekin",
      repeated_failures: "Takroriy muvaffaqiyatsizliklar",
      no_recent_activity: "So'nggi faollik yo'q",
    },
  },
};

export default risk;
